import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { Dimensions } from 'react-native';
import hoistNonReactStatic from 'hoist-non-react-statics';
export var isOrientationLandscape = function isOrientationLandscape(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width > height;
};
export default function withDimensions(WrappedComponent) {
  var _Dimensions$get = Dimensions.get('window'),
      width = _Dimensions$get.width,
      height = _Dimensions$get.height;

  var EnhancedComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(EnhancedComponent, _React$Component);

    function EnhancedComponent() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, EnhancedComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EnhancedComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        dimensions: {
          width: width,
          height: height
        },
        isLandscape: isOrientationLandscape({
          width: width,
          height: height
        })
      });

      _defineProperty(_assertThisInitialized(_this), "handleOrientationChange", function (_ref2) {
        var window = _ref2.window;
        var isLandscape = isOrientationLandscape(window);

        _this.setState({
          isLandscape: isLandscape
        });
      });

      return _this;
    }

    _createClass(EnhancedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        Dimensions.addEventListener('change', this.handleOrientationChange);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        Dimensions.removeEventListener('change', this.handleOrientationChange);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedComponent, _extends({}, this.props, this.state));
      }
    }]);

    return EnhancedComponent;
  }(React.Component);

  _defineProperty(EnhancedComponent, "displayName", "withDimensions(".concat(WrappedComponent.displayName, ")"));

  return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
}